<template>
  <van-field v-model="input" rows="1" autosize :label="label" :type="type" :name="label" :placeholder="placeholderText"
    @input="currentChange" @change="changeInput" :readonly="readonly" :required="required"
    :rules="[{ required: required, message: label+'不可为空' }]" label-class="label-text">
    <template #button>
      <span class="label-text" v-show="appendText">{{appendText}}</span>
    </template>
  </van-field>
</template>

<script>
  export default {
    name: 'FormNormalInput',
    data() {
      return {
        input: ''
      }
    },
    props: {
      label: {
        type: String,
        default: ""
      },
      appendText: {
        type: String,
        default: ""
      },
      value: {},
      type: {
        type: String,
        default: "textarea"
      },
      placeholder: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      // 是否必填
      required: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      placeholderText() {
        let text = this.placeholder ? this.placeholder : '请填写' + this.label
        return this.readonly ? "" : text
      }
    },
    methods: {
      currentChange: function(selVal) {
        this.$emit('input', selVal)
      },
      changeInput: function() {
        this.$emit('change', this.input)
      },
    },
    watch: {
      value(nv) {
        this.input = nv
      }
    },
    mounted: function() {
      this.input = this.value
    }
  }
</script>

<style scoped="scoped">
  .form-append-input {
    display: flex;
    /* border */
  }

  .label-text {
    color: #323233;
    font-size: 14px;
  }
</style>
